import AuthService from '../../state/auth.service';
import axios from 'axios';

import endpoints from '../endpoints';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    delete(id) {
        // console.log("deleting an organization", id);
        return axios
            .delete(endpoints.ORGANIZATION_BASE + '/' + id, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    create(attrs) {
        return axios
            .post(endpoints.ORGANIZATION_BASE, attrs, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Error creating organization on the server...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    get(id) {
        return axios
            .get(endpoints.ORGANIZATION_BASE + '/' + id, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Error getting organization ${id} from the server...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    getPlan(organizationId) {
        let url = `${endpoints.ORGANIZATION_BASE}/${organizationId}/plan`;
        return axios
            .get(url, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    getPractices(organizationId) {
        return axios
            .get(`${endpoints.ORGANIZATION_BASE}/${organizationId}/practices`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            });
    },

    update(id, body) {
        return axios
            .put(`${endpoints.ORGANIZATION_BASE + '/' + id}`, body, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let msg = `Error updating organization "${id}"`;
                if (error.response && error.response.data.message) {
                    msg = error.response.data.message;
                }
                throw msg;
            });
    },

    addMember(organizationId, userId, roleId) {
        return axios
            .post(
                `${endpoints.ORGANIZATION_BASE}/${organizationId}/member`,
                {
                    user_id: userId,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response && response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    removeMember(organizationId, userId) {
        return axios
            .delete(
                `${endpoints.ORGANIZATION_BASE}/${organizationId}/member/${userId}`,
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response && response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    getMembers(organizationId) {
        return axios
            .get(`${endpoints.ORGANIZATION_BASE}/${organizationId}/members`, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    getAdmins(organizationId) {
        return axios
            .get(`${endpoints.ORGANIZATION_BASE}/${organizationId}/admins`, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    getPracticeAdmins(organizationId, practiceId) {
        return axios
            .get(
                `${endpoints.ORGANIZATION_BASE}/${organizationId}/practiceadmins?practice_id=${practiceId}`,
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            });
    },

    getRegions(organizationId) {
        return axios
            .get(`${endpoints.ORGANIZATION_BASE}/${organizationId}/regions`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            });
    },

    getAbbreviations(organizationId) {
        return axios
            .get(
                `${endpoints.ORGANIZATION_BASE}/${organizationId}/abbreviations`,
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            });
    },

    getEvents(organizationId) {
        return axios
            .get(`${endpoints.ORGANIZATION_BASE}/${organizationId}/events`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            });
    },

    getCriteria(organizationId) {
        return axios
            .get(`${endpoints.ORGANIZATION_BASE}/${organizationId}/criteria`, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            });
    },
};
